import React from 'react';
import Modal from '../Common/Modal';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { HTMLTrans } from '../Common/Translations';

function rawMarkup(text) {
  return { __html: text };
}

function modalContents({ contents, store }) {
  return (
    <div className='modal-content'>
      <div className='modal-header align-items-start'>
          <img
            className='logo'
            src={store.logo}
          />
        <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
      </div>

      <div className='modal-body text-left'>
        <div
          className='contents'
          dangerouslySetInnerHTML={rawMarkup(contents)}
        />
      </div>

      <div className='modal-footer justify-content-center'>
        <button
          className='btn btn-lg btn-primary'
          data-dismiss='modal'
        >
          <HTMLTrans id="promotion.termsandconditions_close_button">CLOSE</HTMLTrans>
        </button>
      </div>
    </div>
  );
}

const TermsAndConditions = (props) => {
  if (!props.contents) {
    return null;
  }

  const modalId = `tnc-${props.id}`;

  return (
    <div className='tnc'>
      <a href='#'
        data-toggle='modal'
        data-target={`#${modalId}`}
      >
        {props.tncText}
      </a>
      <Modal size='lg' modalId={modalId}>
        {() => (
          modalContents(props)
        )}
      </Modal>
    </div>
  );
};

export default withStoreDetail(TermsAndConditions);
export const undecorated = TermsAndConditions;



// WEBPACK FOOTER //
// ./src/Promotion/TermsAndConditions.js